import { render } from "./FeedbackReceipt.vue?vue&type=template&id=f8901e26&scoped=true&ts=true"
import script from "./FeedbackReceipt.vue?vue&type=script&lang=ts"
export * from "./FeedbackReceipt.vue?vue&type=script&lang=ts"

import "./FeedbackReceipt.vue?vue&type=style&index=0&id=f8901e26&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8901e26"]])

export default __exports__